import React, { useState, useEffect, useCallback } from 'react';
import './ActiveBountiesPanel.css';

const API_BASE_URL = process.env.REACT_APP_SERVER_URL || '';

const ActiveBountiesPanel = ({ onClose, onOpenGuide }) => {
  const [bounties, setBounties] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchActive = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_BASE_URL}/api/bounty/status`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) return;
      const data = await res.json();
      setBounties(data.activeBounties || []);
    } catch (err) {
      console.error('Failed to fetch active bounties:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchActive();
  }, [fetchActive]);

  return (
    <div className="ab-overlay" onClick={onClose}>
      <div className="ab-modal" onClick={e => e.stopPropagation()}>
        <div className="ab-header">
          <div>
            <h2>📜 Active Bounties</h2>
            <span className="ab-subtitle">Your accepted hunts across all taverns</span>
            {onOpenGuide && (
              <div style={{ marginTop: '8px' }}>
                <button
                  type="button"
                  onClick={() => onOpenGuide('challenge-loops')}
                  style={{
                    background: 'rgba(212, 175, 55, 0.12)',
                    border: '1px solid rgba(212, 175, 55, 0.28)',
                    color: '#f0d58c',
                    borderRadius: '999px',
                    padding: '4px 10px',
                    cursor: 'pointer',
                    fontSize: '0.75rem'
                  }}
                >
                  Guide: bounty strategy
                </button>
              </div>
            )}
          </div>
          <button className="ab-close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="ab-body">
          {loading && <div className="ab-loading">Loading...</div>}

          {!loading && bounties.length === 0 && (
            <div className="ab-empty">
              <div className="ab-empty-icon">📜</div>
              <p>You have no active bounties.</p>
              <p className="ab-empty-hint">Visit any Tavern to pick up daily &amp; weekly hunts!</p>
            </div>
          )}

          {!loading && bounties.length > 0 && (
            <div className="ab-list">
              {bounties.map(b => {
                const pct = Math.min(100, Math.round((b.current / b.target) * 100));
                return (
                  <div key={b.id} className={`ab-bounty-row ${b.complete ? 'ab-complete' : ''}`}>
                    <div className="ab-bounty-header">
                      <span className="ab-bounty-name">
                        {b.type === 'weekly' ? '⭐ ' : ''}
                        Slay {b.target} {b.monster}{b.target > 1 ? 's' : ''}
                      </span>
                      <span className={`ab-bounty-type ${b.type}`}>
                        {b.type === 'weekly' ? 'Weekly' : 'Daily'}
                      </span>
                    </div>
                    <div className="ab-bounty-tavern">{b.tavern}</div>
                    <div className="ab-progress-row">
                      <div className="ab-progress-track">
                        <div
                          className={`ab-progress-fill ${b.complete ? 'complete' : ''}`}
                          style={{ width: `${pct}%` }}
                        />
                      </div>
                      <span className="ab-progress-text">
                        {b.current}/{b.target}
                      </span>
                    </div>
                    <div className="ab-bounty-rewards">
                      <span className="ab-reward">⚔️ {b.xpReward} XP</span>
                      <span className="ab-reward">💰 {b.goldReward} gold</span>
                      {b.complete && <span className="ab-claim-hint">Return to a Tavern to claim!</span>}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActiveBountiesPanel;
